import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
/**
 * Global jquery import,
 * This will be available for the files and included in the bundle at the time of the build.
 */
import * as $ from 'jquery';

declare global {
  interface Window {
    renderReactComponent: (componentInfo: any, timeMode?: any) => any;
    BUILD_NO_ZF: string;
    dataSource: string | undefined;
    renderOrderModule: (id: string) => void;
    //Used in React APP, Once deprecated, this can be removoed
    getUserDetails: () => any;
  }
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
